import React from 'react';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeaderContainer = () => {
  const history = useNavigate();
  const { i18n } = useTranslation();

  const handleHomeClick = () => {
    history(`/${i18n.language}/`, { replace: true });
  };

  const handleExitClick = () => {
    history(`/${i18n.language}/additional-functionalities/sme`, {
      replace: true,
    });
  };

  return (
    <Header
      t={i18n.t}
      language={i18n.language}
      onHomeClick={handleHomeClick}
      onExitClick={handleExitClick}
    />
  );
};

export default React.memo(HeaderContainer);
